import * as ko from "knockout";
import { TaskWithAction } from "../Models/Tasks/TaskWithAction";
export class TaskViewModel {
    loading = ko.observable<boolean>(true);
    tasks = ko.observableArray<TaskWithAction>();
}